<template>
  <v-card-title class="borderBottom  cardSize">
    <v-alert
      v-model="success"
      type="success"
      dismissible
      ref="successAlert"
      class="success-message"
    >Informe publicado con éxito
    </v-alert>
    <v-alert
      v-model="error"
      type="error"
      dismissible
      ref="errorAlert"
      class="error-message"
    >Algo ha fallado en el informe
    </v-alert>
    <div class="d-flex align-center headerCard">
      <div class="d-flex align-center">
        <b> Clase: </b>
        <v-select
          v-model="select"
          :items="classrooms"
          :label="currentClassroom"
          item-text="id"
          item-value="id"
          return-object
          single-line
          @change="classroomSelected"
        ></v-select>
      </div>
      <div class="d-flex align-center">
        <p>
          <b>Fecha: </b>
          <span class="capitalize fontSize">{{currentDiaryDate}}</span>
        </p>
      </div>
      <div>
        <v-btn
          color="warning"
          outlined
          :loading="refreshing"
          :disabled="refreshing"
          @click="resfreshDiary"
        >
          <v-icon dense color="warning">mdi-file-sync-outline</v-icon>
          <b class="buttonText">Descartar</b>
        </v-btn>
        <v-btn
          color="#34417C"
          outlined
          :loading="loading"
          :disabled="loading"
          @click="publishDiary"
        >
          <v-icon dense color="#34417C">mdi-file-document-outline</v-icon>
          <b class="buttonText">Publicar Informe</b>
        </v-btn>
      </div>
    </div>
  </v-card-title>
</template>
<script>
  import { CLASSROOM_REQUEST, PUBLISH_DIARY, REFRESH_DIARY } from '@/store/actions/user'

  export default {
    props: {
      diaryType: String
    },
    data: () => ({
      modal: false,
      date: undefined,
      select: undefined,
      loader: null,
      loading: false,
      refreshing: false,
      finished: false,
      success: false,
      error: false
    }),
    computed: {
      classrooms () {
        return this.$store.state.user.classrooms
      },
      currentClassroom () {
        return this.$route.params.classId
      },
      currentDiaryDate () {
        const options = {
          weekday: 'long',
          year: '2-digit',
          month: '2-digit',
          day: '2-digit'
        }
        const currentDate = this.$store.state.user.diaryDate
        const date = new Date(Date.parse(currentDate))
        const formatDate = date.toLocaleDateString('es-ES', options)
        return formatDate
      }
    },
    methods: {
      resfreshDiary: function () {
        this.refreshing = true
        this.$store.dispatch(REFRESH_DIARY,
          {classId: this.currentClassroom, type: this.diaryType}).then((resp) => {
          this.$emit('studentsLoaded', resp)
          this.refreshing = false
        }).catch(() => {
          this.error = true
          this.refreshing = false
        })
      },
      publishDiary: function () {
        this.loading = true
        this.$store.dispatch(PUBLISH_DIARY,
          {classId: this.currentClassroom}).then((resp) => {
          this.loading = false
          this.success = true
        }).catch(() => {
          this.error = true
          this.loading = false
        })
      },
      classroomSelected: function (classroom) {
        this.$router.push({ name: this.$route.name, params: { classId: classroom.id } }).catch(() => {})
      }
    },
    created () {
      if (!this.classrooms) {
        this.$store.dispatch(CLASSROOM_REQUEST).then((data) => {
          console.log('Lista de clases actualizada')
        }, (error) => { // Failure
          console.log('Error en Lista de clases')
          console.log({error})
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Elements/CardHeader.vue